/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queues_Some_MissingInputs */

const en_queues_some_missing = /** @type {(inputs: Queues_Some_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some counts are not available right now: what is here may not be all.`)
};

/**
* | output |
* | --- |
* | "Some counts are not available right now: what is here may not be all." |
*
* @param {Queues_Some_MissingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queues_some_missing = /** @type {((inputs?: Queues_Some_MissingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queues_Some_MissingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queues_some_missing(inputs)
});